<template>
    <div>
        <headerNav title="明细" />
        <div v-if="cinfo">
            <div class="swiper" v-if="cinfo.detailPicPathList.length>0">
                <van-swipe :autoplay="3000" style="height:auto;border-radius: 8px">
                    <van-swipe-item v-for="(image,index) in cinfo.detailPicPathList" :key="index">
                        <img :src="$baseurl+image" style="width: 100%" />
                    </van-swipe-item>
                    <!-- <van-swipe-item v-for="(image, index) in carouselList" :key="index">
                        <img v-lazy="$baseurl + image.picPath" style="width: 100%" />
                    </van-swipe-item> -->
                </van-swipe>
            </div>
            <div class="fmain">
                <div class="fmain-header">
                    <div class="fmian-logo">
                        <img :src="$baseurl+cinfo.logoPicPath">
                    </div>
                    <div class="fmain-tit">
                        <div class="fmain-big">{{cinfo.title}}</div>
                        <div class="fmain-small">{{cinfo.fTitle}}</div>
                    </div>
                </div>

                <div class="f-tops" v-if="cinfo.productTopBySaleDetailList&&cinfo.productTopBySaleDetailList.length>0">
                    <div class="m-wz">
                        <div class="line-fl">
                            <div class="line"></div>
                        </div>
                    　　<div class="mtit">本月热销</div>
                        <div class="line-fr">
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="top" >
                        <div class="top-content" v-for="(item,index) in cinfo.productTopBySaleDetailList" :key="index">
                            <div class="top-img">
                                <img :src="$baseurl+item.productInfo.productImageUrl">
                                <div class="top-img-wz">
                                    <div class="top-img-wz-top">TOP</div>
                                    <div class="top-img-wz-bottom">{{index+1}}</div>
                                </div>
                            </div>
                            <div class="top-content-wz">
                                <div class="top-content-tit van-ellipsis">
                                    {{item.productInfo.pName}}
                                </div>
                                <div class="top-content-price">
                                    <span class="price">{{item.productInfo.price}}</span>
                                    <!-- <span class="noprice">￥354</span> -->
                                    <span class="salenums">本月热销{{item.productInfo.baseSaleNum+item.productInfo.realSaleNum}}件</span>
                                </div>
                                <div class="btns">
                                    <van-button type="primary" :color="$abctheme.basecolor" @click="godetail(item.productInfo)" style="width:100%;border-radius:4px;height:42px">立即抢购</van-button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

               
            </div>
        </div>
        
         <div class="all-goods" v-if="vlist.length>0">
              <div class="goodtit">
                        <van-icon
                            class="um-btns-btn-icon"
                            :size="18"
                            :color="$abctheme.basecolor"
                            class-prefix="abc-icon"
                            name="quanbu"
                        />全部商品
                         </div>
            <div class="mm-goods">
                <div class="more-goods">
                <van-list
                        v-model="queryparams.loaded"
                        :finished="queryparams.loadingType=='nomore'?true:false"
                        :finished-text="queryparams.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                        @load="loaddata">
                        
                        <div v-for="(item,index) in vlist" :key="index" :class="index%3==1?'more-good more-good-odd':'more-good'" @click="godetail(item)">
                            
                            <div class="good">
                                <img :src="$baseurl+item.productImageUrl">
                                <div class="good-wz">
                                    <div class="good-tit van-multi-ellipsis--l2">
                                    {{item.pName}}
                                    </div>
                                    <div class="good-price">
                                        <span class="price">{{item.userPrice}}</span>
                                        <!-- <span class="noprice">￥89</span> -->
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                </van-list>
              </div>
            </div>
              
            
                    
            </div>

    </div>
</template>
<script>
export default {
    data(){
        return{
            queryparams:{
                loaded:false,
                loadingType: 'more',
                name:"",
                sku:"",
                HeadNavDetailInfoId:0,
                sorting: " sorter desc,id desc",
                maxResultCount: 6,
                skipCount: 0,
                filterindex:0,
                categoryId:0,
                ids:[],
                isIntegral:false
            },
            vid:0,
            vlist:[],
            cinfo:undefined
        }
    },
    created(){
        var query=this.$route.query;
        this.vid=query.id;
        this.queryinfo();
        this.queryparams.HeadNavDetailInfoId=this.vid;
        // this.loaddata();
    },
    methods:{
        godetail(item)
        {
            
            var productsku=item.productSku;
            this.$router.push({path:'/product/'+productsku});
        },
        queryinfo()
        {
            this.ajax.post('/api/services/app/PhoneCom/QueryTopModelbySales?id='+this.vid).then(x=>
            {
                    this.cinfo=x.result;
                    if(!this.cinfo.showAll)
                    {
                        var ids=this.cinfo.productTopBySaleDetailList.map(x=>{ return x.id});
                        this.queryparams.ids=ids;
                        this.loaddata();
                    }
            })
        },
        onRefresh()
        {
            this.loaddata('refresh');
        },
        loaddata(source)
        {
            if (this.queryparams.loadingType === 'loading' || this.queryparams.loadingType === 'nomore') {
                //防止重复加载
                if(source != 'refresh')
                {
                    return;
                } 
            }
            if (source == 'refresh') {
                this.vlist = [];
                this.queryparams.skipCount = this.curskipCount;
            }
            this.queryparams.loadingType = 'loading';
            this.ajax.post('/api/services/app/PhoneCom/QueryTopDetail', this.queryparams).then(x => {
                this.queryparams.skipCount += this.queryparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.vlist = this.vlist.concat(x.result.items);
                console.log(this.vlist);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.queryparams.loadingType = totalcount > (this.queryparams.skipCount) ? 'more' :'nomore';
            }).finally(()=>
            {
                    this.queryparams.loaded=false;
                    this.refreshing=false;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.fmain{
    padding: 10px 12px;
    font-size: 12px;
    background-color: #fff;
}
.fmain-header{
    
}
.fmian-logo{
    width: 50px;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
}
.fmian-logo img{
    width: 100%;
    height: auto;
    
}
.fmain-tit{
    
    display: inline-block;
}
.fmain-big{
    font-size: 16px;
    font-weight: bold;
}
.fmain-small{
    font-size: 12px;
    font-weight: bold;
}
.mtit-left{
    width: 40%;
    border-top: 1px solid red;
}

.f-tops{
    margin-top: 10px;
    margin-bottom: 20px;
}

.m-wz{
    position: relative;
    text-align: center;
}
.mtit{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}



.line-fl{
    position: absolute;
    left: 0;
    top:52%;
    width:38%;
    
}
.line-fr{
    position: absolute;
    right:0;
    top:52%;
    width:38%;
}

.line{
    border-top:1px solid #cccccc;
    width:100%;
}
.top-img{
    margin-top:20px;
    width: 100%;
    position: relative;
}
.top-img img{
    width: 100%;
    height: auto;
    border-radius: 12px 12px 0px 0px;
}
.top-img-wz{
    position: absolute;
    top:10px;
    left:10px;
   background: linear-gradient(45deg, black, #0303036b);
    width: 45px;
    height: 45px;
    border-radius: 50%;
    color:#fff;
    box-shadow: 1px 1px 1px #e6e6e6;

}
.top-img-wz-top{
    position: absolute;
    top:8px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color:#FDD108;
}
.top-img-wz-bottom{
    position: absolute;
    bottom: 2px;
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}
.top-content-wz{
    margin:10px 15px;
}
.top-content-tit{
    
    font-weight: bold;
    font-size: 15px;
}
.top-content-price{
    margin-top:20px;
}
.top-content-price .price::before{
    content: "￥";
    position: absolute;
    left:0;
    bottom: 0;
    font-size: 12px;
}
.top-content-price .price{
    position: relative;
    font-size: 18px;
    padding-left:12px;
    margin-right: 5px;
}
.noprice{
    font-size: 14px;
    color:#a8a8a8;
    text-decoration:line-through;
}
.salenums{
    float: right;
    font-size: 13px;
}
.btns{
    margin-top:10px;
}
.goodtit{
    padding: 0px 10px 10px 10px;
    background-color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
}

.more-goods{
    background-color: #FDD108;
    text-align: left;
}

.more-good{
    margin:2%;
    border-radius: 4px;
    display: inline-block;
    width: 30%;
    background-color: #fff;
    text-align: left;
}
.more-good-odd{
    margin:2% 0 2% 0;
}


.good img{
    border-radius: 4px 4px 0px 0px;
    width: 100%;
}
.good-wz{
    padding: 10px 5px;
}
.good-tit{
    font-size: 12px;
    margin-bottom: 10px;
}
.good-price .price::before{
    content: "￥";
    position: absolute;
    left:0;
    bottom: 0;
    font-size: 12px;
}
.good-price .price{
    position: relative;
    font-size: 16px;
    padding-left:11px;
    margin-right: 4px;
}

.good-price .noprice{
    font-size: 12px;
    color:#a8a8a8;
    text-decoration:line-through;
}
</style>